import h from 'react-hyperscript';

import AuthService from '../../lib/AuthService';

const auth = new AuthService();

export default () => {
  const style = { display: 'none' };

  auth.login({
    redirectUri: window.location.href,
  });

  return h('div', { style }, 'Redirecting to login page...');
};



// WEBPACK FOOTER //
// ./src/components/Login/Login.js